export const GANTT = {
    namespaced: true,
    state: {
        highlightCriticalPath: false,
        clickEventId: null,
        renderGantt: false,
        selectedTasks: []
    },
    getters: {
        GET_HIGHLIGHT_CRITICAL_PATH(state) {
            return state.highlightCriticalPath;
        },
        GET_CLICK_EVENT_ID(state) {
            return state.clickEventId;
        },
        GET_RENDER_GANTT(state) {
            return state.renderGantt
        },
        GET_SELECTED_TASKS(state) {
            return state.selectedTasks
        }
    },
    mutations: {
        SET_HIGHLIGHT_CRITICAL_PATH(state, value) {
            state.highlightCriticalPath = value;
        },
        SET_CLICK_EVENT_ID(state, value) {
            state.clickEventId = value;
        },
        SET_RENDER_GANTT(state, value) {
            state.renderGantt = value;
        },
        SET_SELECTED_TASKS(state, value) {
            state.selectedTasks = value;
        },
    },
}